module.exports = __webpack_public_path__ + "img/logo_horizontal_branco.354dbc85.png";